<template>
    <div
        class="login h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
        id="page-login"
    >
        <div v-if="!brand" class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">

                    <div class="vx-row no-gutter justify-center items-center">

                        <div class="vx-col hidden lg:block lg:w-1/2">
                            <img src="@assets/images/pages/login.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                            <login-form
                                ref="form"
                                :title="$t('global.Login')"
                                :loader="loaded"
                                @submit="login"
                            />
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>

        <div v-if="['enigma', 'luxora', 'leadingsolutions'].includes(brand)">
            <div :class="`login-${brand}__form`">
                <login-form
                    ref="form"
                    :loader="loaded"
                    title="Welcome"
                    @submit="login"
                    description="Sign in to the platform"
                />
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
import {checkPermission} from '@/utils/mixins'
import ErrorHandler from '../../utils/errorHandler'
import LoginForm from "@/views/pages/LoginForm.vue"
import {excludeBrand} from '@/../themeConfig'

export default {
    components: {LoginForm},

    mixins: [checkPermission],

    data() {
        return {
            email: '',
            password: '',
            checkbox_remember_me: false,
            loaded: false
        }
    },

    computed: {
        brand() {
            return excludeBrand.includes(process.env.VUE_APP_BRAND) ? null : process.env.VUE_APP_BRAND
        }
    },

    methods: {
        ...mapActions(['LOGIN']),

        async login(data) {
            try {
                this.loaded = true

                await this.LOGIN({data, ss: true})
                await this.redirect()
            } catch (e) {
                if (e.response && e.response.data) {
                    const response = e.response.data.message
                    this.$refs.form.$refs.form.setErrors({
                        email: response,
                        password: response
                    })
                }
                new ErrorHandler(e).send
            } finally {
                this.loaded = false
            }
        },

        async redirect() {
            const isLead = this.isPermission('statistic_lead.access')
            if (!isLead) {
                await this.$router.push('/home')
            } else {
                await this.$router.push(process.env.VUE_APP_BRAND === 'leadingsolutions' ? '/analytics' : '/statistic/leads')
            }
        }
    },

    async created() {
        const token = localStorage.getItem('token')

        if (!this.$store.getters.authError && token) {
            await this.redirect()
        }
    }
}
</script>

<style lang="scss">
.login-tabs-container {
    min-height: 350px;

    .con-tab {
        padding-bottom: 14px;
    }

    .con-slot-tabs {
        margin-top: 1rem;
    }
}

#page-login {
    .social-login-buttons {
        .bg-facebook {
            background-color: #1551b1
        }

        .bg-twitter {
            background-color: #00aaff
        }

        .bg-google {
            background-color: #4285F4
        }

        .bg-github {
            background-color: #333
        }
    }
}
</style>
